import React from 'react';

import FieldController from '../../../controller/FieldController';
import Const from '../../../util/Constants';
import Util from '../../../util/Util';

class AutomationModelUpdateView extends React.Component {

  constructor(props) {
    super(props);
    this.model = props.model.lead;
    const fields = FieldController.getFilterFields(this.model.fields);
    this.fieldList = [];
    for(let i = 0; i < fields.length; i++) {
      this.fieldList.push({ id: fields[i].id, value: fields[i].fieldKey,
        type: fields[i].field_type, label: fields[i].label_name });
    }
    const modelUpdates = this.getUpdates(props.value);
    this.state = { updates: modelUpdates };
  }

  UNSAFE_componentWillReceiveProps(props) {
    const modelUpdates = this.getUpdates(props.value);
    this.setState({ ...this.state, updates: modelUpdates });
  }

  getUpdates = value => value.filter(value => value.field).map(value => {
    const field = this.fieldList.find(field => field.value === value.field);
    if(field === undefined) return { ...this.value };
    const fOpt = this.getOptionField(field.type);
    const options = this.getOptions(fOpt, field.value, field.type, value.value);
    return { field, value: value.value, ...fOpt, ...options };
  });

  getOptionField = type => {
    const isText = FieldController.showTextFilter(type, FieldController.Equals);
    const isFrom = FieldController.showDateFrom(type, FieldController.Equals);
    const isTo = FieldController.showDateTo(type, FieldController.Equals);
    const isCity = FieldController.showCity(type, FieldController.Equals);
    const isState = FieldController.showState(type, FieldController.Equals);
    const isCountry = FieldController.showCountry(type, FieldController.Equals);
    const isSelect = FieldController.showSelect(type, FieldController.Equals);
    return { isText, isFrom, isTo, isCity, isState, isCountry, isSelect };
  }

  getOptions = (fOpt, field, type, value) => {
    if(!value) value = '';
    let select = '', options = [], from = null, to = null;
    let isMulti = type.includes('multiselect');
    if(fOpt.isCity) {
      options = FieldController.getOptions({ field_type: Const.City });
    } else if(fOpt.isState) {
      options = FieldController.getOptions({ field_type: Const.State });
    } else if(fOpt.isCountry) {
      options = FieldController.getOptions({ field_type: Const.Country });
    } else if(fOpt.isSelect) {
      options = FieldController.getOptions(this.props.model.lead.fields[field]);
    } else if(fOpt.isFrom || fOpt.isTo) {
      if(value.value) {
        const dates = value.value.split(Const.Opt);
        from = Util.serverStringDateTimeToDate(dates[0]);
        to = Util.serverStringDateTimeToDate(dates[1]);
      } else { from = null; to = null; }
    }
    select = isMulti ? options.filter(option => value.includes(`~${option.value}~`))
        : options.find(option => parseInt(value) === option.value);
    return { select, options, from, to};
  }

  render() {
    return this.state.updates.map((filter, i) =>
      <div key={`updates_${i}`} className="col-md-12 condition-select-div">
        <div className="condition-select col-md-3">
          <span>{filter.field.label}</span> &nbsp; To &nbsp;
          <span>
            &nbsp;
            { filter.isText && filter.value }
            { filter.isFrom && Util.serverStringDateTimeToDate(filter.from) }
            { filter.isTo && Util.serverStringDateTimeToDate(filter.from) }
            { (filter.isSelect || filter.isCity || filter.isState || filter.isCountry)
              && filter.select && filter.select.constructor.name === 'Object'
              && filter.select.label }
            { (filter.isSelect || filter.isCity || filter.isState || filter.isCountry)
              && filter.select && filter.select.constructor.name === 'Array'
              && filter.select.map(tmp => tmp.label).join(`${Const.Comn} `) }
          </span>
        </div>
      </div>
    );
  }
}
export default AutomationModelUpdateView;